import React, { FC } from "react";
import { Flex } from "@chakra-ui/react";
import { colours } from "theme/colours";

interface IconTileLayoutProps {
	children: React.ReactNode;
	/** Stack from the top of the tile body instead of vertically centering (default). */
	contentVerticalAlign?: "start" | "center";
	/**
	 * When false, the layout sizes to its content only. Use in full-height tile bodies so the parent
	 * can paint the background to the bottom (avoids an empty strip when a child uses height 100%).
	 */
	fillHeight?: boolean;
}

const IconTileContentLayout: FC<IconTileLayoutProps> = ({ children, contentVerticalAlign = "center", fillHeight = true }) => {
	return (
		<Flex
			height={fillHeight ? "100%" : "auto"}
			gap={"4px"}
			flexDirection={"column"}
			alignItems={"center"}
			textAlign={"center"}
			justifyContent={contentVerticalAlign === "start" ? "flex-start" : "center"}
			fontSize={12}
			color={colours.neutrals[500]}
		>
			{children}
		</Flex>
	);
};

export default IconTileContentLayout;
